import { ICategoryItem } from '../../categories/interfaces';

export const updateCategoryChildren = (
  categories: ICategoryItem[],
  targetId: number,
  newChildren: ICategoryItem[]
): ICategoryItem[] => {
  return categories.map(category => {
    if (category.id === targetId) {
      return {
        ...category,
        children: newChildren,
      };
    }

    if (category.children) {
      return {
        ...category,
        children: updateCategoryChildren(category.children, targetId, newChildren),
      };
    }

    return category;
  });
};
